export default "__VITE_ASSET__2d14317f__"